import { PrismicRichText } from '@prismicio/react';
import Image from 'next/image';
import ContentContainer from 'remote-com-shared/components/ContentContainer';
import styled, { css } from 'styled-components';

import StarIcon from '../assets/star.svg';

import { Title, Section as SectionWrapper, RedLinkStyle } from './AboutStudySlice';

import { transformProperties, fieldHasContent } from '@/src/domains/prismic/helpers';
import { fromTabletBreakpoint } from '@/src/domains/shared/breakpoints';
import { Label } from '@/src/views/GlobalBenefitsReport/slices/BenefitsOverviewSlice';

export const Section = styled(SectionWrapper)`
  background: #fef7f9;
  text-align: left;
  clip-path: ellipse(130% 100% at 50% 0%);

  ${Title} {
    color: var(--secondaryColor);
    max-width: 600px;
  }
`;

export const Description = styled.div`
  ${({ theme }) => theme.typography.body};
  ${RedLinkStyle};

  > * {
    font-size: inherit;
    font-weight: inherit;
    margin: inherit;
  }
`;

export const WideDescriptionWrapper = styled(Description)`
  margin-bottom: 32px;
`;

export const DescriptionWrapper = styled(WideDescriptionWrapper)`
  ${fromTabletBreakpoint(css`
    max-width: 50%;
  `)}
`;

const ImageWrapper = styled.div`
  ${fromTabletBreakpoint(css`
    max-width: 50%;
  `)}
`;

const Content = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

const WhiteBox = styled.div`
  background: var(--colors-blank);
  border-radius: 8px;
  padding: 45px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  > * {
    max-width: 717px;
  }
`;

const BoxTitle = styled.div`
  ${({ theme }) => theme.typography.titleXL};
  font-family: var(--typography-fontBossa);

  > * {
    margin-bottom: 24px;
  }
`;

export function BenefitsSlice({ slice }) {
  const { primary } = transformProperties(slice);
  const { title, description, label, wideDescription, boxTitle, boxDescription, illustration } =
    primary;

  return (
    <Section id="benefits">
      <ContentContainer>
        {fieldHasContent(label) && <Label>{label}</Label>}
        {fieldHasContent(title) && (
          <Title>
            <PrismicRichText field={title} />
          </Title>
        )}
        <Content>
          {fieldHasContent(description) && (
            <DescriptionWrapper>
              <PrismicRichText field={description} />
            </DescriptionWrapper>
          )}
          {illustration && (
            <ImageWrapper>
              <Image
                src={illustration?.url}
                alt={illustration?.alt || ''}
                width={illustration?.dimensions.width}
                height={illustration?.dimensions.height}
                quality="100"
              />
            </ImageWrapper>
          )}
        </Content>
        {fieldHasContent(wideDescription) && (
          <WideDescriptionWrapper>
            <PrismicRichText field={wideDescription} />
          </WideDescriptionWrapper>
        )}
        {fieldHasContent(boxTitle) && (
          <WhiteBox>
            <StarIcon />
            {fieldHasContent(boxTitle) && (
              <BoxTitle>
                <PrismicRichText field={boxTitle} />
              </BoxTitle>
            )}
            {fieldHasContent(boxDescription) && (
              <Description>
                <PrismicRichText field={boxDescription} />
              </Description>
            )}
          </WhiteBox>
        )}
      </ContentContainer>
    </Section>
  );
}
